import React from 'react';

const CandidateCardContext = React.createContext();
export default CandidateCardContext;
